import React from "react";

function IconAvatar({ w, width, h, height }) {

  return (
    <svg xmlns="http://www.w3.org/2000/svg"
      width={w || width || 74.4}
      height={h || height || 73.67}
      fill="none"
      viewBox="0 0 41 40"
    >
      <path
        fill="#AEAEAE"
        fillRule="evenodd"
        d="M0 39.666h20.913V0H0v39.666zM12.861 9.818h5.205v-4.91h-5.204v4.91zm-10.309 0h5.204v-4.91H2.552v4.91zm10.31 9.917h5.204v-4.91h-5.204v4.91zm-10.31 0h5.204v-4.91H2.552v4.91zm10.31 9.916h5.204v-4.91h-5.204v4.91zm-10.31 0h5.204v-4.91H2.552v4.91zM22.386 39.66h4.958V29.7h7.68v9.96l5.035.006-.005-22.378-17.668-.008v22.38zM22.386 16.053H40.06v-2.307H22.386v2.307z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default IconAvatar;